export default {
    namespaced: true,    
    state: {
        obj: {},
        objs: [],
    },
    mutations: {
        setObj(state, pload) {
            state.obj = pload
        },
        setObjs(state, pload) {
            state.objs = pload
        },
    },
    actions: {
        getObj({rootState, commit}, _id){
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "newspromo/" + _id
                fetch (url, {method: 'get', headers: rootState.apiheaders})
                .then (response => response.json())
                .then (response => {
                    console.log(response)
                    commit('setObj', response)
                    resolve(response)
                }, error => {
                    reject(error)
                })            
            })
        },        
        getObjs({rootState, commit}){
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "newspromo/admin"
                fetch (url, {method: 'get', headers: rootState.apiheaders})
                .then (response => response.json())
                .then (response => {
                    commit('setObjs', response)
                    resolve(response)
                }, error => {
                    reject(error)
                })            
            })
        },
        postObj({rootState}, pload){
            return new Promise((resolve, reject) => {
                var url = rootState.config.apiHost + 'newspromo'
                console.log(pload)

                fetch(url, {method: 'post', body:JSON.stringify(pload), headers: {'Content-Type': 'application/json'}})
                .then(response => response.json())
                .then(response => {
                    console.log(response)
                    if (response.result)
                        resolve(response)
                    else
                        reject(response)
                }, error => {
                    reject(error)
                });
            })
        },        
    },
}